const WEEKDAY_HOURS = { MIN: "08:00", MAX: "17:00" };
const WEEKEND_HOURS = { MIN: "09:00", MAX: "16:00" };

const currentHour = new Intl.DateTimeFormat("es-AR", {
  timeZone: "America/Argentina/Buenos_Aires",
  hour: "2-digit",
  minute: "2-digit",
}).format();

const currentDay = new Intl.DateTimeFormat("en-EU", {
  timeZone: "America/Argentina/Buenos_Aires",
  weekday: "short",
}).format();

const isWeekend = ["Sun", "Sat"].includes(currentDay);

export const validateHoursInterval = (): {
  isValid: boolean;
  type?: "max" | "min";
  interval?: { MIN: string; MAX: string };
} => {
  const hourToCompare = isWeekend ? WEEKEND_HOURS : WEEKDAY_HOURS;

  if (currentHour > hourToCompare.MAX) {
    return { isValid: false, type: "max", interval: hourToCompare };
  }

  if (currentHour < hourToCompare.MIN) {
    return { isValid: false, type: "min", interval: hourToCompare };
  }

  return { isValid: true };
};
